/* -----------------------------------------------------------------------------------------------------
  - Created: [20-02-2025] by [SREERAJ]
  - Modified: [YYYY-MM-DD] 
  - Description: This file contains the Roles search filter component
------------------------------------------------------------------------------------------------------- */

import React from 'react';
import '../../LookupsCommonStyles/LookupsTopContainerStyle.css'
import CustomAddButton from '../../../../Components/custom_components/CustomAddButton/CustomAddButton';
import CustomBreadcrumbs from '../../../../Components/custom_components/CustomBreadcrumbs/CustomBreadcrumbs';

function LeaveTypeSearchFilter({ isAddPermission, tableTitle, isAddEdiModalOpen, handleAddEditModal }) {

    const handlemodal = () => {
        handleAddEditModal(!isAddEdiModalOpen)
    }
    const breadcrumbs = ['Settings', tableTitle]

    return (
        <div className='lookup-filter-container'>
            <div className='lookup-filter-sub-container'>
                <div className='technology-lookup-search-left'>
                    <div className="lookup-section-title">{tableTitle}</div>
                    <CustomBreadcrumbs breadcrumbs={breadcrumbs} />
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <div></div>
                    <div className='lookup-action-button-container'>
                        {isAddPermission && <CustomAddButton label={`Add`} onClick={handlemodal} />}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default LeaveTypeSearchFilter;
